import { ReactNode } from 'react';
import styles from './Button.module.css';

interface ButtonProps {
  variant: 'primary' | 'secondary';
  href?: string;
  children: ReactNode;
  icon?: ReactNode;
}

export const Button = ({ variant, href = '#', children, icon }: ButtonProps) => {
  const className = variant === 'primary' ? styles.btnPrimary : styles.btnSecondary;

  return (
    <a href={href} className={className}>
      {icon}
      {children}
    </a>
  );
};
